import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { withUrlGenerator } from '@folklore/react-app';
import 'whatwg-fetch';

import MoreInfo from './MoreInfo';
import LatestNewsCards from '../cards/LatestNews';
import TwitterCard from '../cards/Twitter';

import { setLatestNews as setLatestNewsActions } from '../../actions/SiteActions';

import styles from '../../../styles/partials/latest-news.scss';

const propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
    })),
    urlGenerator: PropTypes.shape({
        route: PropTypes.func,
    }).isRequired,
    setItems: PropTypes.func.isRequired,
    moreInfoLink: PropTypes.string,
};

const defaultProps = {
    items: [],
    moreInfoLink: '#',
};

class LatestNews extends Component {
    constructor(props) {
        super(props);

        this.onItemsLoaded = this.onItemsLoaded.bind(this);
        this.renderCard = this.renderCard.bind(this);

        this.refCards = [];
    }

    componentDidMount() {
        this.fetchItems();
    }

    onItemsLoaded(items) {
        this.props.setItems(items);
    }

    fetchItems() {
        const { urlGenerator } = this.props;
        fetch(urlGenerator.route('api.latest_news'))
            .then(response => response.json())
            .then(this.onItemsLoaded);
    }

    // eslint-disable-next-line class-methods-use-this
    renderCard(item, index) {
        return (
            <div
                key={`card-${item.id}`}
                className={styles.card}
                ref={(ref) => {
                    this.refCards[index] = ref;
                }}
            >
                <LatestNewsCards key={`card-${index}`} {...item} date={item.created_at} />
            </div>
        );
    }

    renderTwitter() {
        const { items } = this.props;
        return (
            <div
                className={styles.card}
                ref={(ref) => {
                    this.refCards[items.length] = ref;
                }}
            >
                <TwitterCard />
            </div>
        );
    }

    // eslint-disable-next-line class-methods-use-this
    renderHeader() {
        const { moreInfoLink } = this.props;
        return (
            <div className={styles.header}>
                <div className={styles.cols}>
                    <div className={styles.col}>
                        <h2 className={styles.title}>
                            <FormattedMessage
                                id="content.latest_news"
                                defaultMessage="Latest News"
                            />
                        </h2>
                    </div>
                    <div className={styles.col}>
                        <MoreInfo
                            label={{
                                id: 'content.more_news',
                                defaultMessage: 'More news',
                            }}
                            link={moreInfoLink}
                        />
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { items } = this.props;
        return (
            <div className={styles.container}>
                {this.renderHeader()}
                <div className={styles.cards}>
                    {items !== null ? items.map(this.renderCard) : null}
                    {items !== null ? this.renderTwitter() : null}
                </div>
            </div>
        );
    }
}

LatestNews.propTypes = propTypes;
LatestNews.defaultProps = defaultProps;

const mapStateToProps = ({ site }) => ({
    items: site.latestNews,
});
const mapDispatchToProps = dispatch => ({
    setItems: items => dispatch(setLatestNewsActions(items)),
});
const WithStateContainer = connect(mapStateToProps, mapDispatchToProps)(LatestNews);
const WithUrlGeneratorContainer = withUrlGenerator()(WithStateContainer);
export default WithUrlGeneratorContainer;



// WEBPACK FOOTER //
// ./js/components/partials/LatestNews.jsx